module.exports = __webpack_public_path__ + "img/icon_04.b578fb2d.svg";